import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'

import defaultLogo from './asset/default_logo.svg'
import pageArrow from './asset/page_arrow.svg'
import seed from './asset/seed.svg'
import store from './asset/store.svg'
import ticket from './asset/ticket.svg'

import useGetAccountParticipationTicket from 'entity/account/useGetAccountParticipationTicket'
import useGetAccountSeedTicket from 'entity/account/useGetAccountSeedTicket'
import useGetAccountStoreTicket from 'entity/account/useGetAccountStoreTicket'

import DefaultButton from 'shared/ui/DefaultButton'
import ControlButton from 'widget/ControlButton'
import PageTitle from 'widget/PageTitle'

import {convertEventStateAsName, END} from 'shared/constant/lookup/eventState'
import timestampCalculator from 'shared/lib/timestampCalculator'
import DefaultModal from 'shared/ui/DefaultModal'
import TicketDetailModal from './ui/TicketDetailModal'
import ticketStatusChecker from 'shared/lib/ticketStatusChecker'

/**
 * @Desc 내 보유 티켓 Page
 */
const MyTicket = () => {
	const navigate = useNavigate()

	const [getStoreTicketList] = useGetAccountStoreTicket()
	const [getSeedTicketList] = useGetAccountSeedTicket()
	const [getParticipationTicketList, fetchParticipationTicketList] =
		useGetAccountParticipationTicket()
	const [tabFlag, setTabFlag] = useState(null)
	const [isTicketOpen, setIsTicketOpen] = useState(null)

	const typeList = [
		{
			icon: store,
			label: '매장 이용권',
			clickEvent: () =>
				setTabFlag((state) => (state === '매장 이용권' ? null : '매장 이용권')),
		},
		{
			icon: seed,
			label: '시드권',
			clickEvent: () =>
				setTabFlag((state) => (state === '시드권' ? null : '시드권')),
		},
		{
			icon: ticket,
			label: '참가권',
			clickEvent: () =>
				setTabFlag((state) => (state === '참가권' ? null : '참가권')),
		},
	]
	return (
		<>
			<Style.Wrapper>
				<PageTitle>내 보유 티켓</PageTitle>

				<Style.TypeList>
					{typeList.map((elem) => (
						<>
							<ControlButton
								icon={elem.icon}
								label={elem.label}
								clickEvent={elem.clickEvent}
							/>

							{elem.label === '매장 이용권' && tabFlag === '매장 이용권' && (
								<Style.TypeChildren>
									{getStoreTicketList?.data?.store_ticket_list?.map((elem) => (
										<Style.StoreElement>
											<img src={elem?.logo_img || defaultLogo} alt='logo' />
											<div>
												<h2>{elem?.franchise_name}</h2>
												<p>
													{elem?.ticket_name} | {elem?.ticket_number} 장
												</p>
											</div>
										</Style.StoreElement>
									))}
									{getStoreTicketList?.data?.store_ticket_list?.length < 1 && (
										<p>보유한 매장 이용권이 없습니다.</p>
									)}
									<DefaultButton
										clickEvent={() => navigate('/my/ticket/store/record')}
									>
										사용 기록 확인하기
									</DefaultButton>
								</Style.TypeChildren>
							)}

							{elem.label === '시드권' && tabFlag === '시드권' && (
								<Style.TypeChildren>
									{getSeedTicketList?.data?.seed_ticket_list?.map((elem) => (
										<Style.StoreElement>
											<img src={elem?.logo_img || defaultLogo} alt='logo' />
											<div>
												<h2>{elem?.name}</h2>
												<p>
													{elem?.ticket_name} | {elem?.ticket_number} 장
												</p>
											</div>
										</Style.StoreElement>
									))}
									{getSeedTicketList?.data?.seed_ticket_list?.length < 1 && (
										<p>보유한 시드권 없습니다.</p>
									)}
									<DefaultButton
										clickEvent={() => navigate('/my/ticket/seed/record')}
									>
										사용 기록 확인하기
									</DefaultButton>
								</Style.TypeChildren>
							)}

							{/* {elem.label === '참가권' && tabFlag === '참가권' && (
								<Style.TypeChildren>
									{getParticipationTicketList?.data?.participation_ticket_list?.map(
										(elem) => (
											<Style.TicketElement
												$deactive={elem?.event_state_flag === END}
											>
												<div>
													<h2>
														{elem?.event_name}{' '}
														{elem?.is_used && <span>사용됨</span>}
													</h2>
													<p>{elem?.address}</p>
													<p>
														{timestampCalculator(elem?.event_date)} |{' '}
														{convertEventStateAsName[elem?.event_state_flag]}
													</p>
												</div>
												<button onClick={() => setIsTicketOpen(elem)}>
													<p>상세보기</p>
													<img src={pageArrow} alt='arrow' />
												</button>
											</Style.TicketElement>
										)
									)}
									{getParticipationTicketList?.data?.participation_ticket_list
										?.length < 1 && <p>보유한 참가권 없습니다.</p>}
								</Style.TypeChildren>
							)} */}

							{elem.label === '참가권' && tabFlag === '참가권' && (
								<Style.TypeChildren>
									{getParticipationTicketList?.data?.participation_ticket_list?.map(
										(elem) => {
											const ticketStatus = ticketStatusChecker(elem)
											return (
												<Style.TicketElement $deactive={!ticketStatus.isValid}>
													<div>
														<h2>
															{elem?.event_name}{' '}
															{!ticketStatus.isValid && (
																<span>{ticketStatus.reason}</span>
															)}
														</h2>
														<p>{elem?.address}</p>
														<p>
															{timestampCalculator(elem?.event_date)} |{' '}
															{convertEventStateAsName[elem?.event_state_flag]}
														</p>
													</div>
													<button onClick={() => setIsTicketOpen(elem)}>
														<p>상세보기</p>
														<img src={pageArrow} alt='arrow' />
													</button>
												</Style.TicketElement>
											)
										}
									)}
									{getParticipationTicketList?.data?.participation_ticket_list
										?.length < 1 && <p>보유한 참가권 없습니다.</p>}
								</Style.TypeChildren>
							)}
						</>
					))}
				</Style.TypeList>
			</Style.Wrapper>

			{/* {isTicketOpen && (
				<DefaultModal title='Ticket' closeEvent={() => setIsTicketOpen(null)}>
					<Style.ModalDiv>
						<h2>{isTicketOpen?.event_name}</h2>
						<Style.ModalArea>
							<p>{isTicketOpen?.address}</p>
							<p>{timestampCalculator(isTicketOpen?.event_date)}</p>
						</Style.ModalArea>
						<Style.ModalArea>
							<p>Ticket Serial Number</p>
							<h1>{isTicketOpen?.serial_number}</h1>
						</Style.ModalArea>
					</Style.ModalDiv>
				</DefaultModal>
			)} */}

			{isTicketOpen && isTicketOpen?.serial_number && (
				<TicketDetailModal
					isTicketOpen={isTicketOpen}
					setIsTicketOpen={setIsTicketOpen}
					fetchParticipationTicketList={fetchParticipationTicketList}
				/>
			)}
		</>
	)
}

export default MyTicket
